var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "codabox-root" },
    [
      _vm.step === 1
        ? _c(
            "w-card",
            { staticClass: "card" },
            [
              _c(
                "w-card-title",
                [
                  _vm._v(" " + _vm._s(_vm.$ct("codabox-documents")) + " "),
                  _c("w-spacer"),
                  _c(
                    "w-link",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("common.close"),
                          expression: "$ct('common.close')",
                        },
                      ],
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "times" } })],
                    1
                  ),
                  _vm.syncing
                    ? _c("w-progress-linear", {
                        staticClass: "full inTitle",
                        attrs: { color: "#1c86f0" },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "w-card-content",
                { staticClass: "grow" },
                [
                  _c("w-tabs", {
                    staticClass: "codabox-tabs",
                    attrs: { tabs: _vm.tabs },
                    model: {
                      value: _vm.activeTab,
                      callback: function ($$v) {
                        _vm.activeTab = $$v
                      },
                      expression: "activeTab",
                    },
                  }),
                  _vm.documents.length === 0 && !_vm.syncing
                    ? _c(
                        "w-row",
                        [
                          _c("w-col", { attrs: { xs: "12" } }, [
                            _c("div", { staticClass: "empty-state" }, [
                              _vm._v(_vm._s(_vm.$ct("codabox-no-documents"))),
                            ]),
                          ]),
                        ],
                        1
                      )
                    : _c("w-data-table", {
                        staticClass: "grow",
                        style: { width: "100%" },
                        attrs: {
                          items: _vm.sortedDocuments,
                          columns: _vm.columns,
                          "selected-items": [],
                        },
                        on: {
                          order: function ($event) {
                            return _vm.onOrder($event)
                          },
                        },
                      }),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      staticClass: "cancel",
                      attrs: { icon: "ban" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      attrs: {
                        disabled: _vm.syncing,
                        icon: "cloud-download-alt",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.sync()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.syncing
                              ? _vm.$ct("codabox-syncing")
                              : _vm.$ct("codabox-sync")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.step === 2
        ? [
            !_vm.previewResult
              ? _c(
                  "w-card",
                  {
                    staticClass: "card step2-card",
                    attrs: { "max-width": "500" },
                  },
                  [
                    _c(
                      "w-card-title",
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$ct("codabox-select-bank-type")) +
                            " "
                        ),
                        _vm.loadingPreview
                          ? _c("w-progress-linear", {
                              staticClass: "full inTitle",
                              attrs: { color: "#1c86f0" },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "w-card-content",
                      [
                        _c(
                          "w-row",
                          [
                            _c(
                              "w-col",
                              { attrs: { xs: "12" } },
                              [
                                _c("app-select-bank-type", {
                                  attrs: {
                                    fancy: "",
                                    "use-ids": "",
                                    "coda-import-only": "",
                                  },
                                  model: {
                                    value: _vm.selectedBankId,
                                    callback: function ($$v) {
                                      _vm.selectedBankId = $$v
                                    },
                                    expression: "selectedBankId",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-card-actions",
                      [
                        _c(
                          "w-button",
                          {
                            staticClass: "cancel",
                            attrs: { icon: "arrow-left" },
                            on: {
                              click: function ($event) {
                                return _vm.backToList()
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$ct("common.back")) + " ")]
                        ),
                        _c("w-spacer"),
                        _c(
                          "w-button",
                          {
                            attrs: {
                              disabled:
                                !_vm.selectedBankId || _vm.loadingPreview,
                              icon: "eye",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.loadPreview()
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$ct("codabox-preview")) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _c("app-coda-preview", {
                  attrs: {
                    items: _vm.previewResult.Banks,
                    "custom-save": _vm.confirmDocument,
                  },
                  on: {
                    close: function ($event) {
                      return _vm.backToList()
                    },
                    done: function ($event) {
                      return _vm.onConfirmDone()
                    },
                  },
                }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }